import { Close } from "@mui/icons-material";
import { ChipProps } from "@mui/material";
import Chip from "../../chip/chip";
import Typography from "../../typography/typography";

interface ChipOrPlaceholderProps {
  data: string[];
  placeholder: string;
  onDelete?: () => void;
  chipProps?: Omit<ChipProps, "label">;
}

const ChipOrPlaceholder: React.FC<ChipOrPlaceholderProps> = ({
  data,
  placeholder,
  onDelete,
  chipProps,
}) => (
  <>
    {data.length ? (
      <Chip
        variant="outlined"
        type="normal"
        label={`${data.length} Selected`}
        deleteIcon={<Close fontSize="large" />}
        onDelete={onDelete}
        onMouseDown={(event) => event.stopPropagation()}
        {...chipProps}
      />
    ) : (
      <Typography color="inherit" type="s3">
        {placeholder}
      </Typography>
    )}
  </>
);

export default ChipOrPlaceholder;
